// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OfferBanner_wrapper__3sLEE","container":"OfferBanner_container__ngZB5","icon":"OfferBanner_icon__3G9IO","link":"OfferBanner_link__2ogUf"};